import { formatDisplay } from '@/utils/format-display';
import { usePreviewTpSl } from '../hooks/usePreviewPnl';

export function Profit() {
    const { tpProfit, takeProfitPercent } = usePreviewTpSl();
    return (
        <p className="text-[10px] font-medium text-green-500 text-left px-1 pt-0.5">
            {tpProfit
                ? `Profit +${formatDisplay(tpProfit, { decimalToShow: 2 })} WLD (${takeProfitPercent}%)`
                : null}
        </p>
    );
}

export function Loss() {
    const { slLoss, stopLossPercent } = usePreviewTpSl();
    return (
        <p className="text-[10px] font-medium text-red-500 text-left px-1 pt-0.5">
            {slLoss
                ? `Loss ${formatDisplay(slLoss, { decimalToShow: 2 })} WLD (${stopLossPercent}%)`
                : null}
        </p>
    );
}
